var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 6.5H19.5C19.8862 6.5 20.2213 6.71897 20.3879 7.03954L13.0547 11.9283C12.7188 12.1523 12.2812 12.1523 11.9453 11.9283L4.61209 7.03953C4.77868 6.71896 5.11377 6.5 5.5 6.5ZM4.5 9.3685V17.5C4.5 18.0523 4.94772 18.5 5.5 18.5H19.5C20.0523 18.5 20.5 18.0523 20.5 17.5V9.36852L14.1641 13.5924C13.1564 14.2642 11.8436 14.2642 10.8359 13.5924L4.5 9.3685ZM2.5 7.5C2.5 5.84315 3.84315 4.5 5.5 4.5H19.5C21.1569 4.5 22.5 5.84315 22.5 7.5V17.5C22.5 19.1569 21.1569 20.5 19.5 20.5H5.5C3.84315 20.5 2.5 19.1569 2.5 17.5V7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLight);
export default __webpack_public_path__ + "static/media/message-light.40f393ffe4c362787061ee71ec5d42d0.svg";
export { ForwardRef as ReactComponent };